import './ChipComponent.scss'
import React from "react";
import {MIXED_CATEGORIES_LABEL, UNCATEGORIZED_LABEL, UNCATEGORIZED_VALUE} from "../../constants";
import {Chip, Tooltip} from "@mui/material";
import {TaxonomyCategory} from "../../stores/TaxonomyCategoryProvider";
import {environment} from "../../env";
import {useStores} from "../../stores";
import {doEllipsisCutoff} from "../../utils/str.utils";


type Props = {
    category: string[] | false | 'UNCATEGORIZED' | 'MIXED_CATEGORIES' | TaxonomyCategory
    showCategoryId?: boolean
}
export const CategorizationViewOnlyComponent: React.FC<Props> = ({category, showCategoryId}) => {
    const {p} = useStores();
    const maxLabelLength = p.p.categoryNameCutoffEllipsisChars ?? environment.categoryNameCutoffEllipsisChars;

    const isArray = Array.isArray(category);
    if (category === false || (isArray && category.every(c => c === UNCATEGORIZED_VALUE) || category === 'UNCATEGORIZED')) {
        return <>{UNCATEGORIZED_LABEL}</>;
    }
    if (category === 'MIXED_CATEGORIES') {
        return <>{MIXED_CATEGORIES_LABEL}</>;
    }

    let cats: string[];
    let customerCategoryId: string;
    if (isArray) {
        cats = category;
        customerCategoryId = '';
    } else {
        const c: TaxonomyCategory = category;
        cats = c.data.labels;
        customerCategoryId = c.data.category_id || '';
    }

    return <>
        {showCategoryId && customerCategoryId && <>
            <span className="part-cat-component-category-id">{customerCategoryId}</span>
        </>}
        {cats.map((c, i) => {
            const categoryLabel = c === UNCATEGORIZED_VALUE ? UNCATEGORIZED_LABEL : c;
            const [s, cutoff] = doEllipsisCutoff(categoryLabel, maxLabelLength);

            const chip = <>
                <Chip
                    className="category-chip"
                    variant="outlined"
                    size="small"
                    label={s}
                />
                {i < cats.length - 1 ? ' > ' : ''}
            </>
            if (cutoff) {
                return <Tooltip key={i} title={categoryLabel}><span>{chip}</span></Tooltip>
            } else {
                return <React.Fragment key={i}>{chip}</React.Fragment>;
            }
        })}
    </>
};